export function getRemoteUrl(remoteName: string): string {
  return `${remoteName}/components`;
}
